class ConfigurationWidgetModel
{
    id?: string;
    key?: string;
    title?: string;
    widgetType?: any;
    category?: Categories | any;
    isHidden: boolean = false;
    subcategory?: string;
    mainTitle?:string;
    criteria?: string;
    apiUrl?: string;
    selectedCard?:string;
    size?: WidgetSize;
    styleType?: string;
    widgetData?: any;
    customData?: any;
    image?: string;
    dataType?: string;
    relationType?: string;
    fieldDescription?: any[];

    mainCategory?: string;
    constructor(customData: any = [])
    {
        this.customData = customData;
    }

    static convertToJSON(data: ConfigurationWidgetModel)
    {
        let jsonData = {
            "id": data.id,
            "key" : data.key,
            "title": data.title,
            "widgetType": data.widgetType,
            "category": data.category,
            "subcategory": data.subcategory,
            "criteria": data.criteria,
            "apiUrl": data.apiUrl,
            "size": data.size,
            "styleType": data.styleType,
            "widgetData": { ...data.widgetData },
            "customData": Array.isArray(data.customData)
                ? [...data.customData]
                : data.customData != null
                    ? { ...data.customData }
                    : {},
            "image": data.image,
            "fieldDescription": data.fieldDescription,
            "isHidden": data.isHidden == null || data.isHidden == undefined ? false : data.isHidden,
            "dataType": data.dataType,
            "relationType": data.relationType,
            "mainTitle":data.mainTitle,
        }
        // Object.assign(jsonData.customData, data.customData)
        return jsonData;
    }
}


enum WidgetType
{
    list = "list",
    grid = "grid",
    cover = "cover",
    watchlist = "watchlist",
    table = "table",
    charts = "charts",
    customList = "customList",
    customGrid = "customGrid",
    customTable = "customTable"
}

enum Categories
{
    social = "social",
    stocks = "stocks",
    crypto = "crypto",
    nft = "nft",
    signals = "signals"
}

enum WidgetSize
{
    small = "small",
    medium = "medium",
    large = "large"
}

export
{
    WidgetSize,
    Categories,
    WidgetType,
    ConfigurationWidgetModel
}